import React, {useEffect} from "react";
import {Col, Row, Typography, Grid, Form, Select, Divider, message} from "antd";
import {Trans, useTranslation} from "react-i18next";
import {InfoCircleOutlined} from "@ant-design/icons";
import {CountdownTimer, LanguageDefaultSwitch, MyButton, MyCheckbox, MyInput, MyPassword} from "../../../components";
import {Link, useNavigate} from "react-router-dom";
import dayjs from "dayjs";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../store";
import {
  fetchRegisterDataAction,
  fetchRegisterDataActionReset,
  fetchVerificationCodeAction
} from "../../../store/pages/profile/actions";
import i18n from "../../../utils/i18n";

import {EntrantRegisterLogo} from "../../../assets";
import {ROUTE_PATH} from "../../../constants";

const {useBreakpoint} = Grid;
const {Option} = Select;

export const EntrantRegister = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation(["register"]);
  const screens = useBreakpoint();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const {verificationCodeState, registerDataState} = useSelector(({profile}: RootState) => ({
    verificationCodeState: profile.verificationCode,
    registerDataState: profile.registerData
  }))

  useEffect(() => {
    if (registerDataState.success) {
      message.success("Register complete!")
      dispatch(fetchRegisterDataActionReset())

      //@ts-ignore
      window.location.replace(process.env.REACT_APP_FULLSTACK_URL)
    }
  }, [registerDataState.success]);


  const onFinish = (values: any) => {

    form.validateFields().then(() => {

      let formData = new FormData();

      let confirmationCode = values.verificationCode.toString().trim();

      formData.append("firstname", values.firstName.trim())
      formData.append("lastname", values.lastName.trim())
      formData.append("password", values.password.trim())
      formData.append("email", values.email.trim())
      formData.append("confirmation_code", confirmationCode)
      // formData.append("type", values.userType)
      formData.append("eds", "true")
      formData.append("language", i18n.language === "kz-KZ" ? "kk" : i18n.language === "ru-RU" ? "ru" : "kk")

      //@ts-ignore
      dispatch(fetchRegisterDataAction(formData))
    })
  }

  const handleSendVerificationCode = () => {
    form.validateFields(["lastName", "firstName", "email"]).then((values) => {
      const formData = new FormData();

      formData.append("email", values.email)


      // @ts-ignore
      dispatch(fetchVerificationCodeAction(formData))
    })

  }

  return (
    <Row style={{height: '100%', background: "#fff"}}>
      <Col span={24} flex={1}>
        <Row justify='space-between' align='middle' style={screens.md ? {padding: 48} : {padding: 16}}>
          <Col>
            <Row align='middle' gutter={12} onClick={() => navigate('/')}>
              <Col >
                <EntrantRegisterLogo/>
              </Col>

              <Col>
                <Typography.Title level={screens.md ? 3 : 5} style={{marginBottom: 0}}>
                  {t("mainTitle")}
                </Typography.Title>
              </Col>
            </Row>
          </Col>

          <Col>
            <LanguageDefaultSwitch/>
          </Col>
        </Row>

        <Row style={screens.md ? {padding: '0 48px 48px 48px'} : {padding: '0 16px 16px 16px'}}>
          <Col span={24}>
            <Typography.Title level={screens.md ? 1 : 3} style={{textAlign: 'center', fontWeight: '700'}}>
              {t("register")}
            </Typography.Title>
          </Col>

          <Col span={24}>
            <Form
              layout='vertical'
              labelCol={{span: 24}}
              wrapperCol={{span: 24}}
              form={form}
              onFinish={onFinish}
            >
              <Row>
                <Col span={24} style={screens.md ? {marginBottom: 24} : {marginBottom: 16}}>
                  <Typography.Title level={screens.md ? 3 : 5} style={{marginBottom: 0}}>
                    1. {t("generalInfo")}
                  </Typography.Title>
                </Col>

                <Col span={24}>
                  <Row gutter={12}>
                    <Col span={8}>
                      <Form.Item name="firstName" label={t("name")}
                                 rules={[{required: true, message: "Enter this"}]}>
                        {/*@ts-ignore*/}
                        <MyInput placeholder={t("namePlaceholder")} height={48}/>
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="lastName" label={t("lastName")}
                                 rules={[{required: true, message: "Enter this"}]}>
                        {/*@ts-ignore*/}
                        <MyInput placeholder={t("lastNamePlaceholder")} height={48}/>
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="middleName" label={t("middleName")}>
                        {/*@ts-ignore*/}
                        <MyInput placeholder={t("middleNamePlaceholder")} height={48}/>
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="email" label={t("email")}
                                 rules={[
                                   {
                                     required: true,
                                     message: 'E-mail должен быть вида example@mail.com',
                                     pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gm)
                                   }
                                 ]}>
                        {/*@ts-ignore*/}
                        <MyInput placeholder={t("emailPlaceholder")} height={48}/>
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item name="verificationCode" label={t("code")}
                                 rules={[{required: true, message: "Введите код подтверждения"}]}>
                        {/*@ts-ignore*/}
                        <MyInput placeholder={t("codePlaceholder")} height={48}/>
                      </Form.Item>
                    </Col>

                    <Col span={8} offset={8}>
                      <Form.Item>
                        {/*@ts-ignore*/}
                        <MyButton size="large" loading={verificationCodeState.loading}
                                  onClick={() => handleSendVerificationCode()}>
                          {verificationCodeState.success ?
                            <CountdownTimer targetTime={dayjs(dayjs()).add(3, "minutes")}/> : t("sendCode")}
                        </MyButton>
                      </Form.Item>
                    </Col>


                    <Col span={8}>
                      <Typography.Paragraph>
                        <InfoCircleOutlined style={{color: '#1890FF', marginRight: 6}}/>
                        {t("codeHint")}
                      </Typography.Paragraph>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={24} style={screens.md ? {marginBottom: 24} : {marginBottom: 16}}>
                  <Typography.Title level={screens.md ? 3 : 5} style={{marginBottom: 0}}>
                    2. {t("passwordSettings")}
                  </Typography.Title>
                </Col>

                <Col span={24}>
                  <Row gutter={12} align='middle'>
                    <Col xs={24} lg={8}>
                      <Row>
                        <Col span={24}>
                          <Form.Item rules={[{
                            required: true,
                            pattern: new RegExp(/(?=[A-Za-z0-9@#$%^&+!=]+$)(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$/gm),
                            message: "Не соответствует паттерну"
                          }]} name="password" label={t("createPassword")}>
                            {/*@ts-ignore*/}
                            <MyPassword placeholder={t("createPasswordPlaceholder")} type='outline'
                                        height={screens.md ? 48 : 40}/>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={24} lg={8}>
                      <Row>
                        <Col span={24}>
                          <Form.Item rules={[{
                            required: true,
                            pattern: new RegExp(/(?=[A-Za-z0-9@#$%^&+!=]+$)(?=.*[0-9])(?=.*[@#$%^&+!=])(?=.{8,}).*$/gm),
                            message: "Не соответствует паттерну"
                          }]} name="passwordConfirmation" label={t("passwordConfirmation")}>
                            {/*@ts-ignore*/}
                            <MyPassword placeholder={t("passwordConfirmation")} type='outline'
                                        height={screens.md ? 48 : 40}/>
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>

                    <Col xs={24} lg={8}>
                      <Row align='bottom'>
                        <Col span={24}>
                          <Typography.Paragraph style={screens.lg ? {marginBottom: 0} : {marginBottom: 16}}>
                            <InfoCircleOutlined style={{color: '#1890FF', marginRight: 6}}/>
                            {t("passwordHint")}
                          </Typography.Paragraph>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row style={{marginTop: 32}}>
                <Col span={24} style={screens.md ? {marginBottom: 24} : {marginBottom: 16}}>
                  <Typography.Title level={screens.md ? 3 : 5} style={{marginBottom: 0}}>
                    3. {t("agreement")}
                  </Typography.Title>
                </Col>

                <Col span={24} >
                  <Row gutter={12} align='middle'>
                    <Col span={24} style={screens.md ? {marginBottom: 24} : {marginBottom: 16}}>
                      <Form.Item name="register:agreement" valuePropName="checked"
                                 rules={[{required: true, message: "Необходимо согласиться с правилами и условиями"}]}>
                        <MyCheckbox size='m'>
                          <Trans i18nKey="agreementCheckbox" components={{ 1: <Link to='https://ffa.object.pscloud.io/skuggcke/oykcaokq/iyuqmagg/cc3de6db0dd6166f89046a6ff331b977f1ac75ee.docx' style={{textDecoration: 'underline'}} /> }}>
                            Я ознакомился <Link to='https://ffa.object.pscloud.io/skuggcke/oykcaokq/iyuqmagg/cc3de6db0dd6166f89046a6ff331b977f1ac75ee.docx' style={{textDecoration: 'underline'}}>с правилами, условиями</Link> и принимаю соглашение
                          </Trans>
                        </MyCheckbox>
                      </Form.Item>
                    </Col>

                    {/*<Col span={24}>*/}
                    {/*  <Row align='middle' gutter={24}>*/}
                    {/*    <Col xs={24} sm={12} md={6} lg={6}*/}
                    {/*         style={screens.md ? {marginBottom: 0} : {marginBottom: 16}}>*/}
                    {/*      <MyButton title={t("EDSButton")} type='primary' ghost height={screens.md ? 48 : 44}/>*/}
                    {/*    </Col>*/}

                    {/*    <Col xs={24} sm={12} md={18} lg={12}>*/}
                    {/*      <div style={{background: '#F2F2F2', borderRadius: 4, padding: '6px 12px'}}>*/}
                    {/*        <Typography.Paragraph style={{marginBottom: 0}}>*/}
                    {/*          {t("certificateNotFound")}*/}
                    {/*        </Typography.Paragraph>*/}
                    {/*        <Typography.Paragraph style={{marginBottom: 0}}>*/}
                    {/*          <Trans i18nKey="EDSHint">*/}
                    {/*            Функция подписи использует программу <Link to='/'>«NCALayer» НУЦ РК</Link>*/}
                    {/*          </Trans>*/}
                    {/*        </Typography.Paragraph>*/}
                    {/*      </div>*/}
                    {/*    </Col>*/}
                    {/*  </Row>*/}
                    {/*</Col>*/}
                  </Row>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Divider style={{marginTop: 16, marginBottom: 32}}/>
                </Col>
              </Row>

              <Row gutter={16} justify='center'>
                <Col>
                  <MyButton onClick={() => navigate("/auth")} title={t("cancel")} height={screens.md ? 48 : 44}/>
                </Col>

                <Col>
                  <MyButton title={t("register")} loading={registerDataState?.loading} height={screens.md ? 48 : 44}
                            type='primary' htmlType="submit" ghost/>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>

    </Row>
  )
}